import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * The EvalTool twin of `simops/$studyId/results/index.tsx` — read that one for
 * why the bare `/results` redirects rather than rendering a fourth copy of
 * Overview. Same rule, kept inside this library: a reader in EvalTool who lands
 * on the bare path should not be moved to another product to see Overview.
 */
export const Route = createFileRoute('/_app/evaltool/$studyId/results/')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/evaltool/$studyId/results/overview',
      params: { studyId: params.studyId },
      search: (prev) => prev,
      replace: true,
    });
  },
});
